// EAN-13 → "X XXXXXX XXXXXX" grouping for readability. Anything else
// passes through unchanged so the picker still sees the raw barcode.
export const groupBarcode = (raw: string | null): string => {
    if (!raw) return "";
    const v = raw.replace(/\s/g, "");
    if (v.length === 13) {
        return `${v.slice(0, 1)} ${v.slice(1, 7)} ${v.slice(7)}`;
    }
    return v;
};
